export enum Constants {
  SET_SPORT = '@contestGenerator/set_sport',
  SET_SITE = '@contestGenerator/set_site',
  SET_SLATE = '@contestGenerator/set_slate',
  SET_GENERATED_SLATE = '@contestGenerator/set_generated_slate',
  SET_LOADING = '@contestGenerator/set_loading',
  SET_POOL_SIZE = '@contestGenerator/set_pool_size',
  SET_CONTEST_PLAYERS = '@contestGenerator/set_contest_players',
  SET_CONTEST_LINEUPS = '@contestGenerator/set_contest_lineups',
  SET_CONTEST_STACKS = '@contestGenerator/set_contest_stacks',
  SET_EXPORTABLE_LINEUPS = '@contestGenerator/set_exportable_lineups',
  SET_BOOST_PLAYER = '@contestGenerator/set_boost_player',
  REMOVE_BOOST_PLAYER = '@contestGenerator/remove_boost_player',
  CLEAR_BOOST_PLAYERS = '@contestGenerator/clear_boost_players',
  SET_CONSTRAINTS = '@contestGenerator/set_constraints',
  SET_RUNBACK = '@contestGenerator/set_runback',
  SET_DIVERSITY = '@contestGenerator/set_diversity',
  SET_FIGHT_STACKS = '@contestGenerator/set_fight_stacks',
  USE_CUSTOM_EXPOSURES = '@contestGenerator/use_custom_exposures',
}